<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :content-class="dialogClass"
    overlay-color="#060f23"
    :overlay-opacity="0.82"
    @keydown.esc="cancel"
  >
    <div class="gc-dialog__card" :class="{ 'gc-dialog__card--danger': isDanger }">
      <div class="gc-dialog__header">
        <h2 class="gc-dialog__title">{{ title }}</h2>
      </div>
      <div v-if="message" class="gc-dialog__body" v-html="message" />
      <div class="gc-dialog__actions">
        <button type="button" class="gc-dialog__btn gc-dialog__btn--text" @click="cancel">
          Cancel
        </button>
        <button
          type="button"
          class="gc-dialog__btn"
          :class="isDanger ? 'gc-dialog__btn--danger' : 'gc-dialog__btn--gold'"
          @click="agree"
        >
          Yes
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: 'error',
      width: 400
    }
  }),

  computed: {
    isDanger() {
      return this.options.color === 'error' || this.options.color === 'red';
    },
    dialogClass() {
      return this.isDanger ? 'gc-dialog gc-dialog--danger' : 'gc-dialog';
    }
  },

  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign({}, this.$options.data().options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/brand';

::v-deep .gc-dialog {
  background: transparent !important;
  box-shadow: none !important;
}

.gc-dialog__card {
  background: linear-gradient(145deg, $gc-panel-dark 0%, $gc-panel-mid 100%);
  border: 1px solid rgba($gc-sky-blue, 0.3);
  border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);
  overflow: hidden;
}

.gc-dialog__card--danger .gc-dialog__header {
  border-bottom-color: rgba(#ff6b6b, 0.35);
}

.gc-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid rgba($gc-sky-blue, 0.15);
  background: rgba($gc-navy, 0.4);
}

.gc-dialog__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: $gc-white;
}

.gc-dialog__body {
  padding: 20px 24px;
  font-size: 14px;
  line-height: 1.55;
  color: rgba($gc-white, 0.88);
  text-align: center;

  ::v-deep em {
    color: $gc-gold-light;
    font-style: normal;
    font-weight: 500;
  }
}

.gc-dialog__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-top: 1px solid rgba($gc-sky-blue, 0.12);
  background: rgba($gc-panel-dark, 0.5);
}

.gc-dialog__btn {
  padding: 8px 18px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &--text {
    color: rgba($gc-white, 0.75);
    background: transparent;

    &:hover {
      color: $gc-white;
      background: rgba($gc-white, 0.06);
    }
  }

  &--gold {
    @include gc-button-gold;
  }

  &--danger {
    color: $gc-white;
    background: linear-gradient(90deg, #ff6b6b 0%, #e85555 100%);
    box-shadow: 0 4px 14px rgba(#ff6b6b, 0.35);

    &:hover {
      box-shadow: 0 6px 18px rgba(#ff6b6b, 0.45);
    }
  }
}
</style>
